import FormComponent from "features/contactUs/components/FormSection/FormComponent";
import React, { useState } from "react";
import "./styles.scss";
import MainPageHeader from "common/components/MainPageHeader";
import MainFooterComponent from "common/components/MainFooterComponent/MainFooterComponent";
import ModalContact from "screens/Landing/components/ModalContact";
import { showMobile } from "helpers/adaptation";
import ContactScreenMobile from "./ContactScreenMobile";

const ContactScreen = () => {
  const [showModalContact, setShowModalContact] = useState(false);
  return (
    <>
      {showMobile && <ContactScreenMobile {...{ showModalContact, setShowModalContact }} />}
      {!showMobile && (
        <div className="wrapper-bg-contact-us">
          <div className="bg-contact-us">
            <MainPageHeader />
            <div className="container-contact-us">
              <div className="wrapper-contact-us">
                <FormComponent variant="compact" onSuccess={() => setShowModalContact(true)} />
              </div>
            </div>
            <ModalContact show={showModalContact} onHide={() => setShowModalContact(false)} />
            <MainFooterComponent />
          </div>
        </div>
      )}
    </>
  );
};

export default ContactScreen;
